// සුවඩි Warranty Icon Component - Reusable Icon System
import React from 'react';
import type { WarrantyIconProps } from './types';

export const WarrantyIcon: React.FC<WarrantyIconProps> = ({ name, className = "" }) => {
  const getCacheBustedIconUrl = (iconName: string) => {
    if (import.meta.env.DEV) {
      const timestamp = Date.now();
      return `/icons/${iconName}.svg?v=${timestamp}`;
    }
    return `/icons/${iconName}.svg`;
  };

  return (
    <img 
      src={getCacheBustedIconUrl(name)} 
      alt="" 
      className={`warranty-icon ${className}`}
      onError={(e) => {
        console.error(`Failed to load icon: ${name}.svg`);
        e.currentTarget.style.display = 'none';
      }}
      role="img"
      aria-hidden="true"
    />
  );
};

export default WarrantyIcon;
